import { render, staticRenderFns } from "./HMCollapse.vue?vue&type=template&id=72ec9103&scoped=true&"
import script from "./HMCollapse.vue?vue&type=script&lang=js&"
export * from "./HMCollapse.vue?vue&type=script&lang=js&"
import style0 from "./HMCollapse.vue?vue&type=style&index=0&id=72ec9103&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ec9103",
  null
  
)

export default component.exports